import axios from "axios";
import { API_URL } from "../constants/config";

export const fetchCertificatesPublicView = async (public_id) => {
  let data = JSON.stringify({
    public_id: public_id,
  });

  let mykademyCourseConfig = {
    method: "post",
    maxBodyLength: Infinity,
    url: `${API_URL}/api/front_end/get_certificates`,
    headers: {
      "Content-Type": "application/json",
    },
    data: data,
  };
  try {
    const response = await axios.request(mykademyCourseConfig);
    const certData = response?.data?.data;
    
    let programConfig = {
      method: "post",
      maxBodyLength: Infinity,
      url: `${API_URL}/api/front_end/get_completed_programs`,
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };

    try {
      const response = await axios.request(programConfig);

      const eporfolioCertData = response?.data?.data?.certificates;
      let certificateData;
      if (eporfolioCertData) {
        const modifiedEporfolioCertData = eporfolioCertData.map((item) => ({
          course_title: item.program_name,
          certificate_url: item.certificate_thumbnail_url,
          issued_date: item.certificate_release_date,
        }));

        return (certificateData = [...certData, ...modifiedEporfolioCertData]);
      } else {
        return (certificateData = [...certData]);
      }
    } catch (error) {
      console.log(error);
      return [];
    }
  } catch (error) {
    console.log(error);
    return [];
  }
};
